import { createSlice } from "@reduxjs/toolkit";
import { ProductAPI } from "../../services/products";

const Products = createSlice({
  name: "Products slice",
  initialState: {
    products: [],
    oneProduct: null,
    categories: [],
    total: null,
    status: null,
  },
  reducers: {
    setOneProduct: (state, action) => {
      state.oneProduct = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ProductAPI.getAll.fulfilled, (state, action) => {
        const { total, products } = action.payload.data;

        state.products = products;
        state.total = total;
      })
      .addCase(ProductAPI.getOne.fulfilled, (state, action) => {
        state.oneProduct = action.payload.data.product;
      })

      .addCase(ProductAPI.getCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
      })

      .addCase(ProductAPI.update.fulfilled, (state, action) => {
        state.status = action.payload.status;
      });
  },
});

export const { setOneProduct } = Products.actions;

export default Products;
